export interface AppSettings {
  workerFilter: WorkerFilterOption;
  ciCoDetails: boolean;
  columnCount: number;
  littleMessageBlock: boolean;
  showImages: boolean;
  showAbsent: boolean;
  showWorkerBackground: boolean;
}

export enum WorkerFilterOption {
  Default, All, CheckedIn
}
